import { render } from "./CouponShare.vue?vue&type=template&id=8b2b8726&scoped=true"
import script from "./CouponShare.vue?vue&type=script&lang=js"
export * from "./CouponShare.vue?vue&type=script&lang=js"

import "./CouponShare.vue?vue&type=style&index=0&id=8b2b8726&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2b8726"]])

export default __exports__